import { all, call, put } from 'redux-saga/effects';
import { requestForSaga } from 'utils/request/request';
import { requestCustomErrorMessage } from 'utils/request/requestCustomErrorMessage';
import {
  DELETE_CA,
  FETCH_CERTIFICATION_AUTHORITIES,
  PATCH_CA,
} from './constants';

import { takeEvery } from 'containers/ErrorBoundary';

function* fetchCertificationAuthorities() {
  try {
    yield put({ type: `${FETCH_CERTIFICATION_AUTHORITIES}_START` });
    const caList = yield call(requestForSaga, {
      url: '/settings/ca',
      method: 'GET',
    });
    yield put({
      type: `${FETCH_CERTIFICATION_AUTHORITIES}_SUCCESS`,
      payload: caList,
    });
  } catch (e) {
    yield put({ type: `${FETCH_CERTIFICATION_AUTHORITIES}_ERROR` });
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}

function* deleteCertificationAuthority(action) {
  try {
    const id = action.payload;
    yield put({ type: `${DELETE_CA}_START` });
    yield call(requestForSaga, {
      url: `/settings/ca/${id}`,
      method: 'DELETE',
    });
    yield put({
      type: `${DELETE_CA}_SUCCESS`,
      payload: id,
    });
  } catch (e) {
    yield put({ type: `${DELETE_CA}_ERROR` });
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}

function* patchCertificationAuthority(action) {
  try {
    const { id, name } = action.payload;
    yield put({ type: `${PATCH_CA}_START` });
    yield call(requestForSaga, {
      url: `/settings/ca/${id}`,
      data: { name },
      method: 'PATCH',
    });
    yield put({
      type: `${PATCH_CA}_SUCCESS`,
      payload: action.payload,
    });
  } catch (e) {
    yield put({ type: `${PATCH_CA}_ERROR` });
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}

export function* defaultSaga() {
  yield all([
    takeEvery(FETCH_CERTIFICATION_AUTHORITIES, fetchCertificationAuthorities),
    takeEvery(DELETE_CA, deleteCertificationAuthority),
    takeEvery(PATCH_CA, patchCertificationAuthority),
  ]);
}

export default defaultSaga;
